import CopyButton from '@/src/components/AppComponents/CopyButton/CopyButton';
import OpenInNewTabButton from '@/src/components/AppComponents/OpenInNewTabButton/OpenInNewTabButton';
import { Button } from '@/src/components/Commons/Button';
import { formatUTxO } from '@/src/lib/MayzSmartDB';
import { CLOSE } from '@/src/lib/SmartDB/Commons/Constants/images';
import { toJson } from '@/src/lib/MayzSmartDB';
import { UTxO } from '@lucid-evolution/lucid';
import styles from './ModalDatum.module.scss';
import { useModalDatum } from './useModalDatum';

export const ModalDatum = ({ uTxO }: { uTxO: UTxO }) => {
    //--------------------------------------
    const { appStore, isRefreshing, datumType, datumObject, isOpen, handleOpen, handleClose } = useModalDatum({ uTxO });
    //--------------------------------------
    return (
        <>
            {uTxO.datum !== undefined ? (
                datumType !== undefined ? (
                    <Button mode="outline-no-arrow" size="small" width={120} onClick={handleOpen}>
                        {datumType} Datum
                    </Button>
                ) : (
                    <p>Unknown Datum</p>
                )
            ) : (
                <p>No Datum</p>
            )}
            {datumObject !== undefined && isOpen === true ? (
                <div className={styles.modal}>
                    <div className={`${styles.main}`}>
                        <div className={styles.popUp}>
                            <>
                                <header className={styles.headerModal}>
                                    <h2 className={styles.titleModal}>Datum</h2>
                                    <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                        <use href={CLOSE}></use>
                                    </svg>
                                </header>
                                <div className={styles.rowSettings}>
                                    UTxO:
                                    {formatUTxO(uTxO.txHash, uTxO.outputIndex)}
                                    <CopyButton content={uTxO.txHash + '#' + uTxO.outputIndex} />
                                    <OpenInNewTabButton
                                        url={
                                            appStore.siteSettings !== undefined
                                                ? `${appStore.siteSettings.getblockfrost_url_explorer_utxo(uTxO.txHash + '#' + uTxO.outputIndex)}`
                                                : ``
                                        }
                                    />
                                </div>
                                <br />
                                <div className={styles.verticalScroll}>
                                    <table className={styles.tableModal}>
                                        <thead>
                                            <tr>
                                                <th>Field</th>
                                                <th>Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(datumObject).map((key: any, index: number) => (
                                                <tr key={index}>
                                                    <td>{key}</td>
                                                    <td>{toJson(datumObject[key], 4)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
    //--------------------------------------
};
